<template>
  <div class="news-warp">
    <adv-item adv-postion-name="column_resource_top_0" />
    <Listbox props-titile="素质教育专区">
      <module-title title="素质教育专区列表" class="module-title" type-title="inside" />
      <el-tabs v-model="activeName" class="tabsNews" @tab-click="handleLoad">
        <el-tab-pane key="all" label="全部" name="all">
          <TabList v-if="activeName==='all'" :props-data="data" />
        </el-tab-pane>
        <el-tab-pane v-for="item in optionsType" :key="item.id" :label="item.classifyName" :name="item.id">
          <TabList v-if="data.classifyId && activeName===item.id" :props-data="data" />
        </el-tab-pane>
      </el-tabs>
    </Listbox>
    <adv-item adv-postion-name="column_resource_bottom_0" />
  </div>
</template>
<script>
import Listbox from '@/views/common/listbox';
import TabList from '@/views/news/tabList';
// 获取API
import getContent from '@/api/content';
export default {
  name: 'Qualityeducation',
  components: {
    Listbox,
    TabList
  },
  data: () => {
    return {
      optionsType: [],
      activeName: '',
      data: {
        interface: {
          list: 'geteduResourceContentsList'
        },
        classifyId: '',
        source: 'qualityeducation'
      }
    };
  },
  watch: {
    $route: {
      handler: function() {
        this.activeName = 'all';
        this.data.classifyId = '';
      },
      immediate: true
    }
  },
  mounted() {
    this.getTypeAll();
  },
  methods: {
    // 获取全部分类
    getTypeAll() {
      getContent['geteduResourceClassifys']()
        .then(res => {
          if (res.data === null || res.data === '' || res.data === 'undefind') {
            this.optionsType = [];
          } else {
            this.optionsType = res.data;
            this.data.classifyId = '';
          }
        });
    },
    // Tab切换
    handleLoad(val) {
      this.data.classifyId = val.name === 'all' ? '' : val.name;
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.news-warp{
  .news-container{
    background-color: #f0f2f5;
    margin-top: 20px;
  }
  .resoure{
    .box-card{
      margin: 10px 0;
    }
  }
  .breadcrumb{
    padding: 20px 0;
  }
  .news-item{
    border-bottom: #f3f3f3 solid 1px;
    padding: 12px 0;
  }
  .message-main{
      .title{
        font-size: 16px;
      }
      .text{
        margin-top: 10px;
        line-height: 22px;
        width: 100%;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 6;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
      }
    }
}

</style>
